
import { Routes } from '@share/constants';
import { ILoginState } from '@share/store/slices';
import { AdminTravBusiness, HasPermission } from '@utils';

import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

const travelerUnauthorizedPaths = [
  '/:accountUsername/company-settings',
  '/:accountUsername/company-team',
  '/:accountUsername/company-integrations',
  '/:accountUsername/company-preferences',
  '/:accountUsername/company-branding',
  '/:accountUsername/company-custom-fields',
  '/:accountUsername/company-merge',
  '/:accountUsername/company-trends',
  '/:accountUsername/company-travel',
  '/:accountUsername/credit-line'
];

const coordinatorUnauthorizedPaths = [
  '/:accountUsername/company-integrations',
  '/:accountUsername/company-preferences',
  '/:accountUsername/company-branding',
  '/:accountUsername/company-custom-fields',
  '/:accountUsername/credit-line'
];

const PrivateRouteNewApp = ({ component: Component, userData, path, ...rest }: any) => {

  const { user, account } = useSelector((state: { loginStore: ILoginState }) => state.loginStore);

  const ISADMIN = HasPermission(user, AdminTravBusiness);

  if (!ISADMIN && (travelerUnauthorizedPaths.includes(path) || coordinatorUnauthorizedPaths.includes(path))) {
    return <Redirect to={Routes.NotAuthorized} />;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        userData?.accessToken ? (
          <Component {...props} />
        ) : (
          <Redirect to={`/${account?.name}`} />
        )
      }
    />
  );
};

export { PrivateRouteNewApp };
